import { useEffect, useState } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LenisContext, BookingContext, BookingCottageContext, useLenis, scrollToId } from "@/context";
import Header from "@/components/tilio/Header";
import Intro from "@/components/tilio/Intro";
import Hero from "@/components/tilio/Hero";
import Features from "@/components/tilio/Features";
import Cottages from "@/components/tilio/Cottages";
import Amenities from "@/components/tilio/Amenities";
import Activities from "@/components/tilio/Activities";
import Holistic from "@/components/tilio/Holistic";
import Location from "@/components/tilio/Location";
import Reviews from "@/components/tilio/Reviews";
import Hosts from "@/components/tilio/Hosts";
import Faq from "@/components/tilio/Faq";
import Reservation from "@/components/tilio/Reservation";
import Footer from "@/components/tilio/Footer";
import RhythmPage from "@/components/tilio/RhythmPage";
import LegalPage from "@/components/tilio/LegalPage";

const Home = () => {
    const lenis = useLenis();
    useEffect(() => {
        if (window.location.hash && lenis) {
            const t = setTimeout(() => scrollToId(lenis, window.location.hash), 500);
            return () => clearTimeout(t);
        }
    }, [lenis]);
    return (
        <main>
            <Intro />
            <Hero />
            <Features />
            <Cottages />
            <Amenities />
            <Activities />
            <Holistic />
            <Location />
            <Reviews />
            <Hosts />
            <Faq />
            <Reservation />
        </main>
    );
};

function App() {
    const [lenis, setLenis] = useState(null);
    const [bookingCottage, setBookingCottage] = useState(null);

    useEffect(() => {
        const instance = new Lenis({ duration: 1.15, smoothWheel: true });
        let rafId;
        const raf = (time) => {
            instance.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        setLenis(instance);
        return () => {
            cancelAnimationFrame(rafId);
            instance.destroy();
        };
    }, []);

    const openBooking = (cottageId = null) => {
        if (cottageId) setBookingCottage(cottageId);
        scrollToId(lenis, "#rezerwacja");
    };

    return (
        <LenisContext.Provider value={lenis}>
            <BookingContext.Provider value={openBooking}>
                <BookingCottageContext.Provider value={bookingCottage}>
                    <div className="min-h-screen bg-white font-sans text-pine">
                        <BrowserRouter>
                            <Header />
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/rytm/:slug" element={<RhythmPage />} />
                                <Route path="/polityka-prywatnosci" element={<LegalPage docKey="polityka-prywatnosci" />} />
                                <Route path="/regulamin" element={<LegalPage docKey="regulamin" />} />
                            </Routes>
                            <Footer />
                        </BrowserRouter>
                        <Toaster
                        position="bottom-center"
                        toastOptions={{
                            style: {
                                background: "#0F1F17",
                                color: "#FAF9F6",
                                border: "1px solid #3E5246",
                                borderRadius: "2px",
                                fontFamily: "'Manrope', sans-serif",
                            },
                        }}
                    />
                    </div>
                </BookingCottageContext.Provider>
            </BookingContext.Provider>
        </LenisContext.Provider>
    );
}

export default App;
